import React from 'react'
import { useCallback } from 'sb-hooks'

import { Href } from 'components/_new/controls'


type TabbedContentBaseTabProps = {
  className?: string
  children?: React.ReactNode
  index: number
  to?: string
  dataTestId?: string
  onClick: (index: number) => void
}

const TabbedContentBaseTab: React.FunctionComponent<TabbedContentBaseTabProps> = (props) => {
  const { children, className, index, to, dataTestId, onClick } = props

  const handleClick = useCallback(() => {
    onClick(index)
  }, [ onClick, index ])

  if (to) {
    return (
      <Href
        className={className}
        to={to}
        data-testid={dataTestId}
        onClick={handleClick}
      >
        {children}
      </Href>
    )
  }

  return (
    <button
      className={className}
      type="button"
      data-testid={dataTestId}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}


export default TabbedContentBaseTab
